import { FunctionComponent } from 'react'
import CollectionActionLabel from '@/components/common/collection-action-label'
import NoStyleNativeButton from '@/components/common/no-style-button'

type AddKolsToCollectionLabelProps = {
  onClick: () => void
}

const AddKolsToCollectionLabel: FunctionComponent<
  AddKolsToCollectionLabelProps
> = ({ onClick }) => {
  return (
    <NoStyleNativeButton onClick={onClick}>
      <CollectionActionLabel type='add' />
    </NoStyleNativeButton>
  )
}

export default AddKolsToCollectionLabel
